export class RelatedEntity {
    public static from({ id, version }: { id: number; version: string; }): RelatedEntity {
        return new RelatedEntity(id, version);
    }

    public constructor(id: number, version: string) {
        this.id = id;
        this.version = version;
    }

    public readonly id: number;
    public readonly version: string;
}